import React, { Component } from "react";
import { queryThirdPartySystem } from "../../../services/author";
import { getPathParams } from "../../../utils/utils";
import styles from './authorAgreement.less';

export default class AuthorAgreement extends Component {
  state={
    thirdPartySystemName: null,
  }

  componentDidMount() {
    const obj = getPathParams(this.props.location.search);
    queryThirdPartySystem({ partyId: obj.partyId, platformCode: obj.platformCode }).then(data =>{
      if(data.code === 0){
        this.setState({
          thirdPartySystemName: data.data && data.data.thirdPartySystemName,
        });
      }
    });
  }

  render() {
    const { thirdPartySystemName } = this.state;
    return (
      <div id="content" className={styles.bg}>
          <div className={styles.date}>
            <text>版本发布日期：2022年12月31日</text>
            <text className={styles.date1}>生效日期：2022年12月31日</text>
          </div>
          <div className={styles.text1}>
            特别授权书
          </div>
          <p>欢迎您注册传化网络货运平台账号并使用平台的服务！</p>
          <p>
            {`本授权书是您向【${thirdPartySystemName}】与（下称“平台合作方”）传化陆鲸科技有限公司及关联公司（本协议中简称“传化网络货运平台”或“我们”）提供的特别授权，就您在使用平台提供的网络货运业务服务时，授权平台合作方向平台提供您在【${thirdPartySystemName}】平台上的数据，以及您授权平台使用前述数据事宜进行明确。`}
            <i>
            您应当认真阅读并遵守本授权内容，
            </i>
            <i className={styles.text2}>您点击或勾选陆鲸相关页面上的“同意”键或者以其他方式确认同意/接受本协议，即表示您同意授权。</i>
            <p>
              本授权书仅为您使用传化网络货运平台相关服务的特别授权，与平台相关页面上的《隐私权政策》并不冲突，具体内容如下：
            </p>
          </p>
          <p className={styles.text3}>
            1、您已认真阅读过平台相关页面上的《传化网络货运平台用户服务协议》及《隐私权政策》，同意使用平台为您提供的服务，愿意遵守上述协议及本协议的相关约定；
          </p>
          <p className={styles.text3}>
            2、您授权平台合作方通过其自身或其关联公司运营的软件（包括但不限于app、网站、客户端，下同）以OpenAPI接口的方式向我们提供您以往和未来的个人信息、浏览记录、交易记录、活动（行车）轨迹等与陆鲸提供的服务相关的数据，并同意平台获取前述信息，授权平台及平台的关联公司对前述信息的不可撤销的使用权。
          </p>
          <p className={styles.text3}>
            3、您承诺您提供的个人信息数据真实、准确、完整、合法有效。您同意我们将其作为您个人的真实有效信息，并且同意该信息可在发生诉讼时作为您的主体资格信息。
          </p>
          <p>
            本协议未做约定的部分，以平台相关页面上《传化网络货运平台用户服务协议》及《法律声明及隐私权政策》中约定的内容为准。
          </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/author/contract/authorAgreement.js